import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import tratamentePardoseli1 from "assets/images/servicii/tratamentePardoseli1.jpg";
import tratamentePardoseli2 from "assets/images/servicii/tratamentePardoseli2.jpg";
import tratamentePardoseli3 from "assets/images/servicii/tratamentePardoseli3.jpg";
import tratPard128 from "assets/images/poze-site/12-8-trat-pard.webp";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={10}>
                        <MKTypography variant="h2" mb={3} color="dark">
                            Tratamente profesionale pentru pardoseli – protecție și recondiționare
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Tratamente profesionale pentru pardoseli reprezintă soluția tehnică de
                            care orice clădire are nevoie pentru a conserva materialele și pentru a
                            păstra o imagine impecabilă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            O pardoseală bine îngrijită nu doar că arată mai bine, dar devine mult
                            mai rezistentă la uzura zilnică și la impactul mecanic.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Prin integrarea acestor soluții în cadrul serviciilor noastre, reușim să
                            oferim o durabilitate crescută suprafețelor de trafic, reducând
                            costurile de mentenanță pe termen lung.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={tratPard128}
                            alt="tratamente profesionale pentru pardoseli"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Servicii specializate de tratament și întreținere a pardoselilor
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Echipa noastră furnizează tehnici avansate pentru a bloca procesul de
                            degradare cauzat de umiditate sau de traficul constant.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Aplicarea acestor bariere protectoare este o etapă determinantă, mai
                            ales în contextul pregătirii spațiilor imediat{" "}
                            <a
                                href="/curatenie-post-construct"
                                style={{ color: "#1A73E8", textDecoration: "underline" }}
                            >
                                după finalizarea construcției
                            </a>{" "}
                            sau a renovării, când materialele noi trebuie sigilate corect. Utilizăm
                            metode calibrate care respectă natura fiecărui suport, asigurând un
                            finisaj de înaltă calitate.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://www.doral-cleaning.ro/static/media/12-9-trat-pard.768d93f8555a200d4490.webp"
                            alt="tratamente profesionale pentru pardoseli"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Lustruire profesională mecanizată
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Această procedură tehnică se realizează după o curățare riguroasă și are
                            rolul de a reda reflexia originală suprafețelor care au devenit opace.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Lustruirea elimină imperfecțiunile minuscule și este un pas solicitat
                            frecvent în întreținerea zonelor de recepție din clădirile de firme sau
                            în cazul strandurilor sau a bazinelor de apă private.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Rezultatul este o suprafață care strălucește uniform, reflectând
                            profesionalismul locației dumneavoastră.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://www.doral-cleaning.ro/static/media/12-4-trat-pard.11290b4b50d1b4d58f51.webp"
                            alt="lustruire profesională pardoseli"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Ceruire de protecție pentru trafic intens
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Prin ceruire, creăm un strat de sacrificiu transparent care preia
                            întreaga presiune a pașilor, protejând materialul original de dedesubt.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Este o metodă foarte eficientă pentru zonele cu flux mare de persoane,
                            facilitând totodată spălarea zilnică.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Recomandăm acest tratament în special în faza de curățenie finală
                            post-constructor, pentru a închide porii materialelor proaspăt montate
                            înainte ca acestea să fie expuse la murdărie.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Polisare și sigilare a porilor
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Sigilarea este procesul prin care blocăm absorbția lichidelor și a
                            grăsimilor în structura pardoselii.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Această protecție asigură un finisaj stabil și rezistent la pete, fiind
                            o componentă importantă a modului în care{" "}
                            <a
                                href="/curatenie-birouri-firme-spatii-comerciale"
                                style={{ color: "#1A73E8", textDecoration: "underline" }}
                            >
                                menținem igiena în centrele comerciale și în birouri
                            </a>
                            .
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Odată sigilată, pardoseala rămâne curată pentru mai mult timp și este
                            mult mai ușor de întreținut.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Recondiționare completă prin șlefuire diamantată
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Când suprafața prezintă degradări avansate, șlefuirea cu pietre
                            diamantate este singura cale de a recupera aspectul inițial.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Această restaurare tehnică este optimă pentru beton, marmură sau mozaic,
                            eliminând straturile uzate și zgârieturile adânci.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            După o astfel de intervenție în cadrul lucrărilor complexe de curățat
                            după constructor, suprafața își recapătă luciul oglindă fără a fi
                            necesară înlocuirea pavimentului.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Proceduri de întreținere adaptate în funcție de tipul suprafeței
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            La Doral Cleaning, procesele de spălare și igienizare se efectuează prin
                            tehnici moderne și cu personal experimentat.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Tehnica de lucru se alege în funcție de natura materialului, rezistența
                            mecanică și gradul de murdărie.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Știm că întreținerea parchetului sau a gresiei diferă complet de{" "}
                            <a
                                href="/curatare-mochete"
                                style={{ color: "#1A73E8", textDecoration: "underline" }}
                            >
                                modul în care igienizăm mochetele sau alte textile
                            </a>
                            , motiv pentru care adaptăm chimia și echipamentele pentru fiecare caz
                            în parte.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Restaurarea pardoselilor din marmură, mozaic și piatră naturală
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru materialele minerale sensibile, folosim curățarea profundă
                            combinată cu cristalizarea chimică, proces care întărește suprafața
                            pietrei.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Acest tratament oferă un luciu spectaculos și este inclus în contractele
                            de
                            <a
                                href="/curatenie-birouri-firme-spatii-comerciale"
                                style={{ color: "#1A73E8", textDecoration: "underline" }}
                            >
                                {" "}
                                mentenanță pentru birourile de prestigiu
                            </a>
                            .
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Cristalizarea nu doar că înfrumusețează, dar transformă marmura într-o
                            barieră dură împotriva factorilor externi.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={tratamentePardoseli1}
                            alt="Restaurarea pardoselilor din marmură, mozaic"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Întreținerea și protecția pardoselilor din PVC și linoleum
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pardoselile elastice au nevoie de o decapare periodică pentru a
                            îndepărta vechile straturi de ceară și murdărie oxidată.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            După această etapă, aplicăm noi straturi de polimeri care sigilează
                            suprafața.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Această procedură este utilă pentru unitățile sanitare, fiind integrată
                            deseori în procesele de igienizare post-renovare, unde standardele de
                            sterilitate sunt critice.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Utilizarea produselor profesionale și a echipamentelor specializate
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Eficiența noastră se bazează pe utilizarea tehnologiei de ultimă
                            generație. În spații de dimensiuni mici, folosim utilaje cu autonomie
                            proprie, iar pentru zonele greu accesibile apelăm la sisteme manuale de
                            precizie.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru suprafețe extinse, intervenim cu mașini automate cu randament
                            ridicat, cu om la bord sau roboți corelați pentru o acoperire rapidă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Aceste dotări ne permit să livrăm rezultate uniforme, chiar și în
                            locații complexe unde efectuăm în paralel igienizarea pardoselilor
                            textile.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={tratamentePardoseli2}
                            alt="Ghid tratamente pardoseli"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Sinteză a tratamentelor pentru pardoseli
                        </MKTypography>

                        <MKBox
                            mb={5}
                            sx={{
                                width: "100%",
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                            }}
                        >
                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    minWidth: "560px",
                                }}
                            >
                                <thead>
                                    <tr style={{ borderBottom: "2px solid #e0e0e0" }}>
                                        <th style={{ padding: "12px", textAlign: "left" }}>
                                            <MKTypography variant="h6" color="dark">
                                                Metodă Tratament
                                            </MKTypography>
                                        </th>
                                        <th style={{ padding: "12px", textAlign: "left" }}>
                                            <MKTypography variant="h6" color="dark">
                                                Suprafață vizată
                                            </MKTypography>
                                        </th>
                                        <th style={{ padding: "12px", textAlign: "left" }}>
                                            <MKTypography variant="h6" color="dark">
                                                Rezultat principal
                                            </MKTypography>
                                        </th>
                                        <th style={{ padding: "12px", textAlign: "left" }}>
                                            <MKTypography variant="h6" color="dark">
                                                Tip Proces
                                            </MKTypography>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography
                                                variant="body2"
                                                color="text"
                                                fontWeight="bold"
                                            >
                                                Cristalizare
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Marmură, Mozaic
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Duritate și luciu oglindă
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Chimic-Mecanic
                                            </MKTypography>
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography
                                                variant="body2"
                                                color="text"
                                                fontWeight="bold"
                                            >
                                                Ceruire
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                PVC, Linoleum
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Protecție la trafic intens
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Strat polimeric
                                            </MKTypography>
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography
                                                variant="body2"
                                                color="text"
                                                fontWeight="bold"
                                            >
                                                Sigilare
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Piatră, Beton
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Rezistență la pete și uleiuri
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Impregnare
                                            </MKTypography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography
                                                variant="body2"
                                                color="text"
                                                fontWeight="bold"
                                            >
                                                Șlefuire
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Granit, Beton uzat
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Restaurare suprafețe degradate
                                            </MKTypography>
                                        </td>
                                        <td style={{ padding: "12px" }}>
                                            <MKTypography variant="body2" color="text">
                                                Mecanic diamantat
                                            </MKTypography>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </MKBox>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Avantajul clientului în colaborarea cu Doral Cleaning
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Oferim servicii profesionale de întreținere și procese complete de
                            recondiționare pentru orice tip de pardoseală.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Specialiștii noștri sunt calificați să gestioneze proiecte de mari
                            dimensiuni, utilizând utilaje automatizate care permit execuția rapidă a
                            lucrărilor.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Alegând abonamentele noastre periodice, vă asigurați că investiția
                            dumneavoastră în finisaje este protejată pe termen lung prin metode
                            verificate tehnic.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Sfaturile noastre pentru o durabilitate crescută a pardoselii
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru zonele cu trafic mediu, recomandăm o spălare mecanizată la
                            fiecare 2–3 zile pentru a elimina granulele de nisip care pot zgâria
                            finisajul.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Sigilarea pardoselilor imediat după montaj este cel mai bun mod de a
                            preveni uzura timpurie.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            În cazul lemnului, respectați fișa de întreținere și utilizați doar
                            produsele dedicate curățării parchetului.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            De asemenea, dacă aveți zone mixte, nu uitați să solicitați periodic și
                            o spălare în profunzime a suprafețelor textile pentru a menține un nivel
                            de igienă uniform în toată locația.
                        </MKTypography>

                        <MKTypography variant="h3" mb={3} color="dark">
                            Checklist pentru pregătirea spațiului
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={5}>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Degajați complet suprafața de obiecte mici și cabluri electrice.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Semnalați echipei zonele unde există plăci desprinse sau plinte
                                degradate.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Asigurați accesul facil la surse de apă și canalizare pentru
                                utilaje.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Opriți sistemul de încălzire prin pardoseală înainte de începerea
                                lucrării.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Planificați un interval de minim 4 ore în care traficul să fie
                                complet oprit.
                            </MKTypography>
                        </MKBox>

                        <MKBox
                            component="img"
                            src={tratamentePardoseli3}
                            alt="checklist tratamente pardoseala"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKTypography variant="h3" mb={3} color="dark">
                            Eficiență și protecție durabilă cu Doral Cleaning
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Echipa Doral Cleaning transformă întreținerea pardoselilor într-o
                            procedură sigură și eficientă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Ne bazăm pe un studiu atent al materialului pentru a stabili metoda de
                            curățare optimă, garantând un spațiu curat și protejat împotriva
                            trecerii timpului.
                        </MKTypography>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
